import { useEffect, useRef } from 'react'
import type { Ref } from 'react'
import type { TextareaProps } from './Textarea.types'
import './Textarea.scss'

export function Textarea({
  error = false,
  className = '',
  maxLength,
  onChange,
  value,
  ref,
  ...props
}: TextareaProps & { ref?: Ref<HTMLTextAreaElement> }) {
  const internalRef = useRef<HTMLTextAreaElement>(null)
  const textareaRef = (ref as React.RefObject<HTMLTextAreaElement>) || internalRef

  // Auto-resize Funktion
  const autoResize = () => {
    const textarea = textareaRef.current
    if (!textarea) return

    // Setze initial auf CSS-Höhe
    textarea.style.height = ''

    // Prüfe ob Content größer als die Mindesthöhe ist
    const minHeight = 36 // CSS min-height
    if (textarea.scrollHeight > minHeight) {
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  }

  useEffect(() => {
    autoResize()
    // Nur bei neuem Wert messen — autoResize entsteht jeden Render neu.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    autoResize()
    if (onChange) onChange(e)
  }

  const textareaClassName = `textarea ${error ? 'textarea--error' : ''} ${className}`.trim()

  return (
    <textarea
      ref={textareaRef}
      className={textareaClassName}
      spellCheck={false}
      maxLength={maxLength}
      value={value}
      onChange={handleChange}
      {...props}
    />
  )
}
